import React from 'react';
const stats = [{
  value: '+1.800',
  label: 'estudiantes confían'
}, {
  value: '3',
  label: 'niveles disponibles'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}, {
  value: '🇦🇷',
  label: 'Todo el país'
}];
const testimonials = [{
  initials: 'MR',
  quote: '"Llegué a tercer año con apuntes de 5 compañeros distintos que no coincidían entre sí. Con el Nivel 1 del Megapack tuve por primera vez un sistema claro para entender qué estudiar y en qué orden. Aprobé Evaluación Nutricional con 9."',
  author: '— Martina R., Córdoba | 3° año Nutrición UNC'
}, {
  initials: 'JV',
  quote: '"Siempre llegaba a los parciales sin saber si había estudiado lo correcto. Con el Nivel 2 eso cambió: tengo el sistema de estudio armado, sé cómo organizarme y cómo repasar. Ya aprobé 4 materias con él."',
  author: '— Julián V., Buenos Aires | 4° año Nutrición UBA'
}, {
  initials: 'CP',
  quote: '"Me tomé el Nivel 3 con los editables y fue un cambio total. Tengo todo organizado por ejes, sé qué tomo usar para cada materia y llegué a los finales mucho más tranquila y preparada."',
  author: '— Camila P., Rosario | 3° año Nutrición UNR'
}];
export function SocialProof() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(220,252,231) 15%, rgb(220,252,231) 85%, rgb(240,253,244) 100%)'
  }} data-id="element-338">
      <div className="mx-auto max-w-4xl" data-id="element-339">

        {/* ── STATS GRID ── */}
        <div className="mb-8 grid grid-cols-2 md:grid-cols-4 gap-3 text-center" data-id="element-340">
          {stats.map(stat => <div key={stat.label} data-id="element-341">
              <div className="text-2xl sm:text-4xl leading-[32px] sm:leading-[40px] font-black text-gray-900" data-id="element-342">
                {stat.value}
              </div>
              <div className="mt-1 text-[10px] sm:text-xs font-semibold text-green-700" data-id="element-343">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* ── TESTIMONIALS GRID ── */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-344">
          {testimonials.map(t => <div key={t.initials} className="flex items-start gap-2 bg-white/80 border border-green-400/30 rounded-lg p-3 shadow-sm" data-id="element-345">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-black text-green-700" style={{
            background: 'linear-gradient(135deg, rgba(21,128,61,0.12) 0%, rgba(34,197,94,0.12) 100%)'
          }} data-id="element-346">
                {t.initials}
              </div>
              <div data-id="element-347">
                <div className="mb-1 text-[10px] text-green-600" data-id="element-348">
                  ⭐⭐⭐⭐⭐
                </div>
                <p className="text-xs font-medium text-gray-900 m-0" data-id="element-349">
                  {t.quote}
                </p>
                <p className="text-[10px] text-gray-500 mt-1 mb-0" data-id="element-350">
                  {t.author}
                </p>
              </div>
            </div>)}
        </div>

      </div>
    </section>;
}